module.exports = __webpack_public_path__ + "static/media/parceiro-premed.1cdddbea.jp2";